/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_AreaInputs */

const en_company_area = /** @type {(inputs: Company_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Area`)
};

const de_company_area = /** @type {(inputs: Company_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensbereich`)
};

/**
* | output |
* | --- |
* | "Company Area" |
*
* @param {Company_AreaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_area = /** @type {((inputs?: Company_AreaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_AreaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_area(inputs)
	return en_company_area(inputs)
});